import { actionTypes, } from '../constants';
export const initialState = {
    extensionsList: [],
    hasNewExtensions: false,
};
export const reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.SET_EXTENSIONS:
            return setExtensions(state, payload);
        case actionTypes.RESET_STATE:
            return reset();
        case actionTypes.SET_HAS_NEW_EXTENSIONS:
            return setHasNewExtensions(state, payload);
        default:
            return state;
    }
};
function setExtensions(state, extensionsList) {
    return {
        ...state,
        extensionsList: [...extensionsList],
    };
}
function reset() {
    return { ...initialState };
}
function setHasNewExtensions(state, payload) {
    return {
        ...state,
        hasNewExtensions: payload,
    };
}
export default reducer;
